// extracted by mini-css-extract-plugin
export var introBody = "SendQuoteSectionIntro-module--intro-body--29528";
export var title = "SendQuoteSectionIntro-module--title--1105a";